// extracted by mini-css-extract-plugin
module.exports = {"declaration":"ABEmhSmyvcm+R+yMT00+eQ==","footer":"I2GnTKT7zdv2ZpLDUvpHhg=="};